<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('Summary')"  class="title d-sm-flex pointer" :class="{'active' : title === 'Summary'}">
            <div class="my-auto">
              課程總覽
            </div>
          </div>
          <div @click="goTitlePage('Info')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Info'}">
            <div class="my-auto">
              學習紀錄
            </div>
          </div>
          <div @click="goTitlePage('Curve')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Curve'}">
            <div class="my-auto">
              學習曲線
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex my-3 justify-content-between align-items-center">
        <div>
          <select class="mx-2" v-model="selected">
            <option v-for="(item, index) in channels" :key="index" :value="index">
              <span>
                {{ item.name }}
              </span>
            </option>
          </select>
          <select v-if="channels[selected] && channels[selected].child" class="mx-2" v-model="subSelected">
            <option v-for="(item, index) in channels[selected].child" :key="index" :value="index">
              <span>
                {{ item.name }}
              </span>
            </option>
          </select>
          <select class="mx-2" v-model="contentSelected">
            <option value="0" disabled selected>請選擇課程</option>
            <option v-for="(item, index) in channels[selected].child[subSelected].items" :key="index" :value="item.id">
              <span>
                {{ item.name }}
              </span>
            </option>
          </select>

          <select class="mx-2" v-model="lessonSelected">
            <option value="0" disabled selected>請選擇課程單元</option>
            <option v-for="(item, index) in lesson" :key="index" :value="item.id">
              <span>
                {{ item.name }}
              </span>
            </option>
          </select>
        </div>
        <div>
          <button v-if="lessonSummary.length>0"  type="button" @click="downloadExcel" class="btn btn-success">下載報表</button>
          <button v-else type="button" disabled class="btn btn-success">下載清單</button>
          <button type="button" @click="sendReport()" class="btn btn-success mx-2">寄送全班報表</button>
        </div>
      </div>
      <div class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>姓名</th>
                <th>學習時間</th>
                <th>學習時數</th>
                <th>第一次分數</th>
                <th>口說分數</th>
                <th>學習次數</th>
              </tr>
              <tr v-for="(item, index) in lessonSummary" :key="index">
                <td class="rwd-td" data-th="學生姓名">
                  {{item.name}}
                </td>
                <td data-th="最近學習日期">
                  {{item.recent}}
                </td>
                <td data-th="學習時間">
                  {{item.time}}
                </td>
                <td data-th="第一次成績">
                  {{item.first_score}}
                </td>
                <td data-th="口說分數"  v-if="item.score !== 'N/A'" class="pointer" style="text-decoration:underline" @click="goPage(item.student_id)">
                  {{item.speak}}
                </td>
                <td data-th="口說分數" style="color:#888" v-else>
                  {{item.speak}}
                </td>
                <td data-th="練習次數">
                  {{item.finish_speak_count}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="lessonSelected===0" class="remind mt-5">
          <h3>請選擇課程單元</h3>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import api from '../../store/api'
export default {
  name: 'Summary',
  data () {
    return {
      lessonSummary: [],
      selected: 0,
      subSelected: 0,
      contentSelected: 0,
      lessonSelected: 0,
      lessonId: 0,
      channels: [],
      lesson: [],
      title: 'Summary'
    }
  },computed: {
    groupId () {
      return this.$route.params.groupId
    }
  },
  mounted () {
    this.getChannels()
    // this.getLessonSummary()
  },
  watch: {
    selected (val) {
      this.subSelected = 0
      this.contentSelected = 0
      this.lessonSelected = 0
      this.lessonSummary = []
    },
    subSelected (val) {
      this.contentSelected = 0
      this.lessonSelected = 0
      this.lessonSummary = []
    },
    contentSelected (val) {
      this.lessonSelected = 0
      this.lessonSummary = []
      this.getLesson(val)
    },
    lessonSelected (val) {
      this.getLessonSummary(val)
    }
  },
  methods: {
    toPercent (num) {
      if ( Number(num*100).toFixed(0) >= 100) {
        return '100%'
      } else {
        if (num>0) {
          return Number(num*100).toFixed(0) + '%'
        } else {
            return '0%'
        }
      }
    },
    async getChannels () {
      const { data } = await api.get('/contents/channels')
      this.channels = data.data
    },
    async getLesson (id) {
      console.log(id)
      const { data } = await api.get(`/contents/package_courses/${id}`)
      this.lesson = data.data.courses
    },
    toPage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    async getLessonSummary() {
      const params = {
        page: this.pageIndex,
        pageSize: 100
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.lessonSelected}`, { params })
      this.lessonSummary = data.data
      // this.avgScore = data.avg_score
      // this.courseName = data.course_name
      // this.studentCount =  data.student_count
      // this.passCount =  data.pass_count
      this.page = data.pageIndex
      this.pageCount = data.pageCount
    },
    goPage (id) {
      this.$router.push({ name: 'VoiceRecord', params: { groupId: this.groupId, lessonId: this.lessonSelected, studentId: id } })
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../vendor/Export2Excel')
        const tHeader = [ '學生姓名', '最近學習日期', '學習時間', '第一次成績', '練習次數','口說成績' ]
        const filterVal = [ 'name', 'recent', 'time', 'first_score' , 'finish_speak_count', 'score', ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '學習紀錄')
      })
    },
    async downloadExcel () {
      const params = {
        page: this.pageIndex,
        pageSize: 1000
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.lessonSelected}`, { params })
      this.export2Excel(data.data)
    },
    async sendReport () {
      const vm = this
      vm.$swal({
        title: '請輸入email',
        text: '報表將同步寄送此信箱，若不需要請留空。',
        input: 'text',
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        inputValidator: function(value) {
          return new Promise(function(resolve, reject) {
            try {
              api.get(`reports/groups/${vm.groupId}/learning?cc=${value}`)
              vm.$swal({
                title: '報表計算完成後，將自動發送至您的信箱',
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: '確定'
              })
            } catch (error) {
              if (error) {
                vm.$swal({
                  title: '目前報表功能異常，請聯絡管理者',
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: '確定'
                })
              }
            }
            resolve()
          })
        }
      })
    }
  },
  components: {
    // Video
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  .target-box {
    // width: 270px;
    height: 180px;
    overflow: hidden;
    background-color: #ededed;
    border: .5px solid rgb(202, 202, 202);
    border-radius: 5px;
    .target-title {
      padding: 8px;
      background-color: #0041b9;
      color: #fff;
    }
    .target-content {
      text-align: left;
      padding: 20px;
      height: 80%;
    }
    .progress {
      margin: 5px;
      height: 10px;
      background-color: #fff;
      .progress-bar {
        background-color: red;
      }
    }
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
